<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <div class="common-new-title mode2">
            <span>菜单管理</span>
            <a class="icon-index-1 jm-fr" @click="handleAdd">
              <el-button type="primary" size="medium">
                创建新菜单
              </el-button>
            </a>
          </div>
          <div class="slider-block">
            <span style="text-align: center; display: block; color: #f60">横向滚动表格</span>
            <el-slider v-model="sliderVal" :show-tooltip="false" :max="sliderMaxWidth"/>
          </div>
          <div class="table-tree">
            <vxe-table
              :auto-resize="true"
              resizable
              show-overflow
              row-id="id"
              ref="menuTreeTable"
              v-loading="loading"
              :tree-config="{ expandAll: true }"
              :row-config="{ isHover: true }"
              :data="menuData">
              <vxe-column field="id" title="Id" width="50"></vxe-column>
              <vxe-column field="title" title="名称" min-width="250" tree-node></vxe-column>
              <vxe-column field="sort" title="排序" width="50"></vxe-column>
              <vxe-column field="group" title="分组" min-width="150"></vxe-column>
              <vxe-column field="status" title="访问限制" width="80">
                <template #default="{ row }">
                  <el-tag size="small" type="" v-if="row.status === 1">允许</el-tag>
                  <el-tag size="small" type="warning" v-else>禁止</el-tag>
                </template>
              </vxe-column>
              <vxe-column field="group_limit_field" title="必填参数" min-width="100"></vxe-column>
              <!-- <vxe-column field="is_old" title="新老系统" width="80">
                <template #default="{ row }">
                  <el-tag size="small" type="danger" v-if="row.is_old">老</el-tag>
                  <el-tag size="small" type="success" v-else>新</el-tag>
                </template>
              </vxe-column>
              <vxe-column field="fib_url" title="老系统URL" min-width="200"></vxe-column> -->
              <vxe-column field="url" title="新系统URL" min-width="200"></vxe-column>
              <vxe-column field="rule_url" title="权限URL" min-width="200"></vxe-column>
              <vxe-column field="hide" title="隐藏" width="80">
                <template #default="{ row }">
                  <el-tag size="small" type="danger" v-if="row.hide === 1">隐藏</el-tag>
                  <el-tag size="small" type="success" v-else>显示</el-tag>
                </template>
              </vxe-column>
              <vxe-column field="countries" title="办理国家" min-width="200"></vxe-column>
              <vxe-column field="lastColumn" title="操作" min-width="200" fixed="right">
                <template #default="{ row }">
                  <el-button
                    size="small"
                    type="primary"
                    @click="handleEdit(row)">编辑</el-button>
                  <el-button
                    size="small"
                    type="danger"
                    @click="handleDelete(row)">删除</el-button>
                </template>
              </vxe-column>
            </vxe-table>
          </div>
        </div>
        <!--编辑弹层 S-->
        <el-dialog
          :title="formData.id ? '编辑菜单' : '新增菜单'"
          class="dialog"
          :visible.sync="dialogVisible"
        >
          <div class="form-wrapper">
            <el-form
              ref="formData"
              :rules="rules"
              :model="formData"
              label-width="150px">
              <el-form-item label="上级目录">
                <!-- <template v-if="formData.id">
                {{ fullMenuTitle }}
              </template> -->
                <el-tooltip effect="dark" :content="fullMenuTitle" :disabled="!fullMenuTitle">
                  <el-cascader
                    clearable
                    :disabled="false"
                    class="jm-input280"
                    v-model="formData.parentIds"
                    :change-on-select="true"
                    :options="formOptions"
                    @change="handelChange">
                  </el-cascader>
                </el-tooltip>
              </el-form-item>

              <el-form-item label="名称" prop="title">
                <el-input class="jm-input280" v-model="formData.title" />
              </el-form-item>
              <el-form-item label="系统路由">
                <el-input class="jm-input280" v-model="formData.url"/>
              </el-form-item>
              <el-form-item label="原蓝火链接(旧版)" v-if="formData.fib_url">
                <el-input class="jm-input280" v-model="formData.fib_url"/>
              </el-form-item>
              <el-form-item label="权限URL">
                <el-input class="jm-input280" v-model="formData.rule_url"/>
              </el-form-item>
              <el-form-item label="同级排序">
                <el-input class="jm-input280" v-model="formData.sort"/>
              </el-form-item>
              <el-form-item label="导航分组">
                <el-input class="jm-input280" v-model="formData.group"/>
              </el-form-item>
              <el-form-item label="分组必要字段">
                <el-input class="jm-input280" v-model="formData.group_limit_field"/>
              </el-form-item>
              <!-- <el-form-item label="新老系统">
                <el-switch
                  active-text="老"
                  inactive-text="新"
                  :active-value="1"
                  :inactive-value="0"
                  v-model="formData.is_old"/>
              </el-form-item> -->
              <el-form-item label="菜单隐藏">
                <el-switch
                  active-text="隐藏"
                  inactive-text="显示"
                  :active-value="1"
                  :inactive-value="0"
                  v-model="formData.hide"/>
              </el-form-item>
              <el-form-item label="访问限制">
                <el-switch
                  active-text="允许"
                  inactive-text="禁止"
                  :active-value="1"
                  :inactive-value="0"
                  v-model="formData.status"/>
              </el-form-item>
              <el-form-item label="菜单所属办理国家">
                <el-select
                  class="jm-input280"
                  multiple
                  v-model="formData.countrys"
                >
                  <el-option
                    v-for="item in countries"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id"/>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('formData')">{{ formData.id ? '保存' : '创建' }}菜单</el-button>
                  <!--<el-button @click="resetForm('ruleForm')">重置</el-button>-->
              </el-form-item>
            </el-form>
          </div>
        </el-dialog>
      <!--编辑弹层 E-->
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import xeUtils from 'xe-utils';
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';

Vue.use(VXETable);

export default {
  data() {
    return {
      loading: false,
      sliderMaxWidth: 2000, // 相当于表格宽度，可以计算获取
      sliderVal: 0,
      menuData: [],
      searchData: {
        pid: this.$route.params.pid,
      },
      dialogVisible: false,
      formData: {
        parentIds: []
      },
      formOptions: [],
      rules: {
        title: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ]
      }
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
  },
  computed: {
    ...mapGetters([
      'onlineDict',
    ]),
    countries() {
      const countries = Object.assign([], this.onlineDict.country);
      if (countries[countries.length - 1].id !== -1) {
        countries.push({ id: -1, value: '英美部门' });
      }
      if (countries[countries.length - 1].id !== -2) {
        countries.push({ id: -2, value: '亚欧部门' });
      }
      return countries;
    },
    fullMenuTitle() {
      return this.getMenuTitle(this.formData.pid);
    }
  },
  methods: {
    handelChange(val) {
      if (val.length) {
        this.formData.parentIds = val;
        this.formData.pid = val[val.length - 1];
      } else {
        this.formData.parentIds = [0];
        this.formData.pid = 0;
      }
    },
    findMenuItem(id) {
      return xeUtils.findTree(this.menuData, item => item.id === id);
    },
    fetchMenu () {
      this.loading = true;
      this.dialogVisible = false;
      this.$http._post({
        url: '/index/Power/menu',
        data: {},
      }).then(({ data }) => {
        this.menuData = data;
        this.$nextTick(() => {
          this.$refs.menuTreeTable.setAllTreeExpand(true);
          this.loading = false;
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    handleAdd() { // 添加
      this.formData = {
        pid: 0, parentIds: []
      };
      this.formOptions = this.getMenuOptions(null);
      this.dialogVisible = true;
    },
    handleEdit(row) { // 编辑
      this.formData = Object.assign({ parentIds: row.path }, row);
      this.formOptions = this.getMenuOptions(this.formData.id);
      this.dialogVisible = true;
    },
    handleDelete(row) { // 删除
      this.$confirm('此操作将永久删除该菜单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          url: '/index/Power/menuDel',
          data: { id: row.id },
        }).then((res) => {
          if (res.result === 0) {
            this.$message({ type: 'success', message: '菜单删除成功!' });
            this.fetchMenu();
          }
        });
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' });
      });
    },
    submitForm(formName) {
      const parentIds = this.formData.parentIds;
      this.formData.pid = parentIds[parentIds.length - 1];
      this.formData.id
        ? this.submitFormEdit(formName)
        : this.submitFormAdd(formName);
    },
    submitFormAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (typeof this.formData.pid === 'undefined') {
            this.formData.pid = 0;
          }
          this.$http._post({
            url: '/index/Power/menuAdd',
            data: this.formData,
          }).then((res) => {
            if (res.result === 0) {
              this.$message({ type: 'success', message: '菜单创建成功!' });
              this.fetchMenu();
            }
          });
        } else {
          this.$message.error('请按提示补全表单！');
          return false;
        }
      });
    },
    submitFormEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('此操作将永久改变该菜单, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$http._post({
              url: '/index/Power/menuEdit',
              data: this.formData,
            }).then((res) => {
              if (res.result === 0) {
                this.$message({ type: 'success', message: '菜单编辑成功!' });
                this.fetchMenu();
              }
            });
          }).catch(() => {
            this.$message({ type: 'info', message: '已取消编辑' });
          });
        } else {
          this.$message.error('请按提示补全表单！');
          return false;
        }
      });
    },
    getMenuItem(menu, disabledId) {
      let result = {
        value: menu.id,
        label: menu.title,
        disabled: menu.id === disabledId
      };

      if (menu.children && menu.children.length > 0) {
        const children = menu.children.map(m => this.getMenuItem(m, disabledId));
        result = Object.assign({ children: children }, result);
      }
      return result;
    },
    getMenuTitle(pid) {
      const title = '顶层菜单';

      if (!pid) {
        return title;
      }

      const menuItem = this.findMenuItem(pid);
      if (menuItem.nodes) {
        return [title, ...menuItem.nodes.map(m => m.title)].join(' / ');
      }
      return '';
    },
    getMenuOptions(disabledId) {
      return [
        this.getMenuItem({ id: 0, title: '顶层菜单', children: this.menuData }, disabledId)
      ];
    },
  },
  mounted() {
    this.fetchMenu();
  },
  watch: {
    sliderVal(val) {
      if (val) {
        setTimeout(() => {
          if (this.sliderVal !== 0) {
            this.$el.querySelector('.vxe-table--body-wrapper').scrollLeft = val;
          } else {
            this.$el.querySelector('.vxe-table--body-wrapper').scrollLeft = 0;
          }
        }, 80);
      }
    },
  },
};
</script>
<style>
.form-wrapper {
  padding: 20px 20px 1px 20px;
  position: relative;
}
</style>
